<template>
  <span class="simpleWorkflow _addExpression">
    <b-form-textarea
      ref="textarea"
      v-model="writeMethod.expression"
      @keyup="updateAction"
      placeholder="type { to show available suggestions"
    />

    <span>{{ msg }}</span>
    <b-form-select
      v-model="writeMethod.targetCell"
      :options="dataGrid_cellsSelect(gridId)"
      size="sm"
      @change="updateAction"
    />
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
import AutoSuggest from '@/libs/auto-suggest/src/AutoSuggest'
import { mapState } from 'vuex'

export default {
  props: [
    'eventBus',
    'writeMethod',
    'writeMethodIdx',
    'action',
    'actionIdx',
    'msg',
    'gridId',
  ],
  data() {
    return {
      autoSuggestInstance: null,
    }
  },
  computed: {
    ...mapGetters(['dataGrid_cellsSelect']),
    ...mapState(['dataGrid_options']),
    dataSourceOptions() {
      const list = []
      let value = ''
      let name = ''

      //date functions
      value = `getDate()`
      name = `CurrentDate`
      list.push({ on: [name], show: name, insertText: value })

      value = `moment(getDate()).format('l')`
      name = `CurrentDate(Day Format)`
      list.push({ on: [name], show: name, insertText: value })

      value = `fbUser.email`
      name = `UserEmail`
      list.push({ on: [name], show: name, insertText: value })

      value = `fbUser.displayName`
      name = `UserName`
      list.push({ on: [name], show: name, insertText: value })

      value = `fbUser.uid`
      name = `UserID`
      list.push({ on: [name], show: name, insertText: value })

      if (!this.dataGrid_options) return list
      if (!this.dataGrid_options[this.gridId]) return list

      for (let field in this.dataGrid_options[this.gridId].meta) {
        let f = this.dataGrid_options[this.gridId].meta[field]

        // console.log(f.displayName, f)
        value = `row.${field}`
        name = `row.${field}`
        list.push({ on: [name], show: name, insertText: value })

        if (f.type == 'date') {
          value = `row.$${field}$MonthYear`
          name = `row.${field}$MonthYear`
          list.push({ on: [name], show: name, insertText: value })

          value = `row.$${field}$Month`
          name = `row.${field}$Month`
          list.push({ on: [name], show: name, insertText: value })

          value = `row.$${field}$YearWeek`
          name = `row.${field}$YearWeek`
          list.push({ on: [name], show: name, insertText: value })

          value = `row.$${field}$Date`
          name = `row.${field}$Date`
          list.push({ on: [name], show: name, insertText: value })
        }

        if (f.lookUpTable) {
          let lookupFields = this.dataGrid_options[f.lookUpTable].meta
          value = `row.$${field}$display`
          name = `row.${field}$display`

          list.push({ on: [name], show: name, insertText: value })

          for (let refField in lookupFields) {
            value = `row.$${field}.${refField}`
            name = `row.${field}.${refField}`

            list.push({ on: [name], show: name, insertText: value })
          }
        }
      }
      // console.log(list)
      return list
    },
  },
  methods: {
    updateAction() {
      this.eventBus.$emit(
        'setAction',
        Object.assign({}, this.action),
        this.actionIdx
      )
    },
  },
  mounted() {
    this.autoSuggestInstance = new AutoSuggest(
      {
        dropdownParentEl: $('#simple-workflow-wrapper').get(0),
        caseSensitive: false,
        maxSuggestions: 100,
        suggestions: [
          {
            trigger: '{',
            values: this.dataSourceOptions,
          },
          {
            trigger: '@',
            values: this.dataSourceOptions,
          },
        ],
      },
      this.$refs.textarea.$el
    )
  },
  beforeDestroy() {
    this.autoSuggestInstance.destroy()
    $('#simple-workflow-wrapper')
      .find('> .auto-suggest-dropdown')
      .remove()
  },
}
</script>
